(function () {
  if (window.__qqHeroAnchorNav && typeof window.__qqHeroAnchorNav.initAll === 'function') {
    window.__qqHeroAnchorNav.initAll();
    return;
  }

  var ROOT_SELECTOR = '[data-qq-anchor-nav]';
  var LINK_SELECTOR = '[data-qq-anchor-link]';
  var initialized = new WeakSet();
  var instances = new WeakMap();

  function toNumber(value, fallback) {
    var parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  function getCssLength(name) {
    var value = window.getComputedStyle(document.documentElement).getPropertyValue(name);
    return toNumber(value, 0);
  }

  function getStickyHeaderHeight() {
    var cssHeight = Math.max(getCssLength('--sticky-header-height'), getCssLength('--height-header'));
    if (cssHeight > 0) {
      return cssHeight;
    }

    var selectors = [
      '#shopify-section-header',
      '.shopify-section-header-sticky',
      'sticky-header',
      '.header-wrapper',
      'header'
    ];

    for (var i = 0; i < selectors.length; i += 1) {
      var node = document.querySelector(selectors[i]);
      if (!node) {
        continue;
      }
      var style = window.getComputedStyle(node);
      var rect = node.getBoundingClientRect();
      if ((style.position === 'sticky' || style.position === 'fixed') && rect.height > 0 && rect.bottom > 0) {
        return rect.height;
      }
    }

    return 0;
  }

  function getMainSections(root) {
    var main = document.getElementById('MainContent') || root.closest('main') || document.querySelector('main');
    if (!main) {
      return [];
    }

    return Array.prototype.slice.call(main.children).filter(function (item) {
      return item.nodeType === 1;
    });
  }

  function getTargetId(link) {
    var targetId = (link.dataset.targetId || '').trim().replace(/^#/, '');
    if (targetId) {
      return targetId;
    }

    var href = link.getAttribute('href') || '';
    var hashIndex = href.indexOf('#');
    if (hashIndex >= 0) {
      return href.slice(hashIndex + 1).trim();
    }

    return '';
  }

  function resolveTarget(root, link) {
    var targetId = getTargetId(link);
    if (targetId) {
      var targetByAnchor = resolveTargetByAnchorId(root, targetId);
      if (targetByAnchor) {
        return targetByAnchor;
      }

      var targetById = document.getElementById(targetId);
      if (targetById) {
        return targetById;
      }
    }

    var position = parseInt(link.dataset.sectionPosition || '0', 10);
    if (!position) {
      return null;
    }

    var sections = getMainSections(root);
    return sections[position - 1] || null;
  }

  function resolveTargetByAnchorId(root, targetId) {
    var candidates = Array.prototype.slice.call(document.querySelectorAll('[data-qq-anchor-id]')).filter(function (item) {
      return item.getAttribute('data-qq-anchor-id') === targetId;
    });

    if (!candidates.length) {
      return null;
    }

    if (root.getAttribute('data-qq-anchor-id') === targetId) {
      return root;
    }

    var afterRoot = candidates.filter(function (item) {
      return root.compareDocumentPosition(item) & Node.DOCUMENT_POSITION_FOLLOWING;
    });

    return afterRoot[0] || candidates[0];
  }

  function getScrollOffset(root) {
    var nav = root.querySelector('.qq-1-hero-anchor-nav__nav');
    var navHeight = nav ? nav.getBoundingClientRect().height : 0;
    var extra = toNumber(root.dataset.scrollOffsetExtra, 12);
    return getStickyHeaderHeight() + navHeight + extra;
  }

  function keepLinkVisible(root, link) {
    var scroller = root.querySelector('.qq-1-hero-anchor-nav__links');
    if (!scroller || !link || scroller.scrollWidth <= scroller.clientWidth) {
      return;
    }

    var linkLeft = link.offsetLeft;
    var linkCenter = linkLeft + (link.offsetWidth / 2);
    var targetLeft = linkCenter - (scroller.clientWidth / 2);
    var maxLeft = scroller.scrollWidth - scroller.clientWidth;

    scroller.scrollTo({
      left: Math.max(0, Math.min(maxLeft, targetLeft)),
      behavior: 'smooth'
    });
  }

  function setActive(root, activeLink) {
    var links = root.querySelectorAll(LINK_SELECTOR);
    links.forEach(function (link) {
      if (link === activeLink) {
        var wasActive = link.getAttribute('aria-current') === 'true';
        link.setAttribute('aria-current', 'true');
        if (!wasActive) {
          keepLinkVisible(root, link);
        }
      } else {
        link.removeAttribute('aria-current');
      }
    });
  }

  function collectTargets(root) {
    return Array.prototype.slice.call(root.querySelectorAll(LINK_SELECTOR)).map(function (link) {
      return {
        link: link,
        target: resolveTarget(root, link)
      };
    }).filter(function (item) {
      return item.target;
    });
  }

  function updateActive(root) {
    var offset = getScrollOffset(root) + 1;
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    var current = null;

    collectTargets(root).forEach(function (item) {
      var top = item.target.getBoundingClientRect().top + scrollTop - offset;
      if (scrollTop >= top) {
        current = item;
      }
    });

    if (current) {
      setActive(root, current.link);
    }
  }

  function scrollToTarget(root, link) {
    var target = resolveTarget(root, link);
    if (!target) {
      return;
    }

    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
    var top = target.getBoundingClientRect().top + scrollTop - getScrollOffset(root);
    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth'
    });
    setActive(root, link);
  }

  function init(root) {
    if (!root || initialized.has(root)) {
      return;
    }

    initialized.add(root);

    var onClick = function (event) {
      var clicked = event.target.nodeType === 1 ? event.target : event.target.parentElement;
      var link = clicked ? clicked.closest(LINK_SELECTOR) : null;
      if (!link || !root.contains(link)) {
        return;
      }

      if (resolveTarget(root, link)) {
        event.preventDefault();
        scrollToTarget(root, link);
      }
    };

    root.addEventListener('click', onClick);

    var ticking = false;
    var onScroll = function () {
      if (ticking) {
        return;
      }
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        updateActive(root);
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    instances.set(root, {
      onClick: onClick,
      onScroll: onScroll
    });
    updateActive(root);
  }

  function initAll() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(init);
  }

  function destroy(root) {
    var instance = instances.get(root);
    if (!root || !instance) {
      return;
    }

    root.removeEventListener('click', instance.onClick);
    window.removeEventListener('scroll', instance.onScroll);
    window.removeEventListener('resize', instance.onScroll);
    instances.delete(root);
    initialized.delete(root);
  }

  window.__qqHeroAnchorNav = {
    initAll: initAll,
    destroy: destroy
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target.querySelector(ROOT_SELECTOR));
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target.querySelector(ROOT_SELECTOR));
  });
})();
